export default class Slider {
  /*
   * Fires first
   */
  constructor($slider) {
    this.$sliderContainer = $($slider);
    this.$slider = this.$sliderContainer.find('.js-slider__wrapper');
    this.$sliderArrows = this.$sliderContainer.find('.js-slider__arrows');
    this.$prevBtn = this.$sliderArrows.find('.js-slider__arrows-prev');
    this.$nextBtn = this.$sliderArrows.find('.js-slider__arrows-next');

    // progress bars
    this.$time = 2;
    this.$progressBar = $('.hero-carousel__progress-bar');
    this.$sliderWrapper = $('.hero-carousel__wrapper');
    // this.$isPaused;
    // this.$tick;
    // this.$percentTime;
    // this.$progressBarCount = 0;

    // this.slide = 'js-slider__slide';
    this.options = {
      dots: false,
      arrows: false,
      slidesToShow: 1,
    };
    this.initSlider();
    // Add events
    this.addEvents();
    // this.startProgressbar();
  }

  /*
   * Initialise slider
   */
  initSlider() {
    var sliderDots;
    sliderDots = this.$sliderContainer.find('.js-slider__dots');

    // Get arguments in section
    if (this.$sliderContainer.find('.js-config').length) {
      var sectionConfig = this.$sliderContainer.find('.js-config');
      this.options = JSON.parse(sectionConfig.text());
    }

    // Edit arguments based on dom
    if (sliderDots.length) {
      this.options.appendDots = sliderDots;
      this.options.dots = true;
    }

    // if (this.options.infinite !== true) {
    //     this.$prevBtn.addClass('slider__arrows_arrow--inactive')
    // }
    this.$slider.slick(this.options);
  }

  /*
   * Add events
   */
  addEvents() {
    if (this.$sliderArrows.length) {
      this.$prevBtn.on('click', () => {
        this.$slider.slick('slickPrev');
      });
      this.$nextBtn.on('click', () => {
        this.$slider.slick('slickNext');
      });
    }
  }

  // startProgressbar() {
  // 	this.resetProgressbar();
  // 	this.$percentTime = 0;
  // 	this.$isPaused = false;
  // 	var that = this;
  // 	that.tick = setInterval(function() {
  // 		that.interval();
  // 	}, 10);
  // }


  // interval() {
  // 	var that = this;
  // 	that.$sliderWrapper.on({
  // 		mouseenter: function() {
  // 			that.$isPaused = true;
  // 		},
  // 		mouseleave: function() {
  // 			that.$isPaused = false;
  // 		},
  // 	});
  //
  //     // this.$progressBar.each(function(){
  //     //     let count = 0;
  //     //     const wrapper = $(this).parent();
  //     //     const dataIndex = wrapper.attr('data-index');
  // 	//
  //     // } )
  //
  //
  // 	if (that.$isPaused === false) {
  // 		this.$percentTime += 0.5 / (this.$time + 0.1);
  // 		this.$progressBar.css({
  // 			width: this.$percentTime + '%',
  // 		});
  // 		if (this.$percentTime >= 100) {
  // 			this.$slider.slick('slickNext');
  // 			this.startProgressbar();
  // 		}
  // 	}
  // }
  //
  // resetProgressbar() {
  // 	this.$progressBar.css({
  // 		width: 0 + '%',
  // 	});
  // 	var that = this;
  // 	clearTimeout(that.tick);
  // }
}



// WEBPACK FOOTER //
// ./scripts/modules/Slider.js